<template>
	<div class="info-item">
		<div style="padding-bottom: 5px;display: flex;align-items: center;">
			<el-divider direction="vertical"></el-divider>
			<span>{{title}}</span>
		</div>
		<div class="form-box" v-if="form">
            <el-table :data="form" border size="mini" :header-cell-style="headerCellStyle">
				<el-table-column prop="yaer" label="年" width="100"></el-table-column>
				<el-table-column prop="currency" label="货币种类" :show-overflow-tooltip="true" width="120"> </el-table-column>
				<el-table-column prop="qySumZc" label="企业总资产(万)" :show-overflow-tooltip="true" width="120"> </el-table-column>
				<el-table-column prop="sumFz" label="企业总负债(万)" :show-overflow-tooltip="true" width="120"> </el-table-column>
				<el-table-column prop="ldZc" label="流动资产(万)" :show-overflow-tooltip="true" width="120"> </el-table-column>
				<el-table-column prop="ldFz" label="流动负债(万)" :show-overflow-tooltip="true" width="120"> </el-table-column>
				<el-table-column prop="yySr" label="营业收入(万)" :show-overflow-tooltip="true" width="120"> </el-table-column>
				<el-table-column prop="netProfit" label="净利润(万)" :show-overflow-tooltip="true" width="120"> </el-table-column>
				<el-table-column prop="zcFzl" label="资产负债率" :show-overflow-tooltip="true" width="120"> </el-table-column>
				<el-table-column prop="ldBl" label="流动比率" :show-overflow-tooltip="true" width="120"> </el-table-column>
				<el-table-column prop="sumZcSyl" label="总资产收益率" :show-overflow-tooltip="true" width="120"> </el-table-column>
				<el-table-column prop="remark" label="备注" :show-overflow-tooltip="true"> </el-table-column>
			</el-table>
		</div>
		<div v-else class="no-info-box">请补充相关信息</div>
	</div>
</template>

<script>
	export default {
		name: "ShowBankInfo",
		computed: {
			currencyInfo:function(){
				return this.$store.getters['app/currencyInfo'];
			},
		},
		props:['title','form'],
		data() {
			return {
				imgHost:process.env.VUE_APP_BASE_API,
				tableData: [],
			};
		},
		mounted() {
		},
		methods: {
            formatIsMainNum: function(row) {
				return row.isMainNum == 0 ? '是' : '否';
			},
		}
	};
</script>
<style scoped="scoped">
</style>
